export default __webpack_public_path__ + "static/media/030104202188103.52af09f3.png";